<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div style="height: 80vh; overflow-y: auto; overflow-x: hidden;">
      <!-- Avatar Row -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-start flex-col sm:flex-row">
            <img :src="picture != null && picture.length > 457 ? picture : this.$defaultPicture" class="mr-8" style="height:133px; width:133px;" />
            <div class="flex">
              <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ data.name }}</p>

              <vs-button v-if="user[0].userId == $store.state.userData.userId" class="mr-4 mb-4" @click="showPopupPictureTool = true">Resim Değiştir</vs-button>

              <vs-checkbox class="mr-4 mb-4" v-model="user[0].status"> Aktif </vs-checkbox>
            </div>
          </div>
        </div>
      </div>

      <vs-prompt
        style="z-index: 100001;"
        :vs-title="'Resim Düzenle # ' + user[0].userId"
        vs-accept-text="Kaydet"
        vs-cancel-text="Kapat"
        vs-button-cancel="border"
        :vs-active.sync="showPopupPictureTool"
        :vs-buttons-hidden="true"
        @vs-cancel="showPopupPictureTool = false"
      >
        <div>
          <vue-anka-cropper
            :options="{
              aspectRatio: 0,
              closeOnSave: true,
              cropArea: 'box',
              croppedHeight: 400,
              croppedWidth: 400,
              cropperHeight: false,
              dropareaMessage: 'Bilgisayarınızdan resim seçiniz veya sürükleyiniz.',
              frameLineDash: [5, 3],
              frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
              handleFillColor: 'rgba(255, 255, 255, 0.2)',
              handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
              handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
              handleSize: 10,
              handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
              layoutBreakpoint: 850,
              maxCropperHeight: 768,
              maxFileSize: 8000000,
              overlayFill: 'rgba(0, 0, 0, 0.5)',
              previewOnDrag: true,
              previewQuality: 0.65,
              resultQuality: 0.8,
              resultMimeType: 'image/jpeg',
              selectButtonLabel: 'Dosya Seçiniz',
              showPreview: true,
              uploadData: {},
              uploadTo: false,
            }"
            @cropper-saved="savePersonnelPicture($event)"
          ></vue-anka-cropper>
        </div>
      </vs-prompt>

      <!-- Content Row -->
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input class="w-full mt-4" label="Adı Soyadı" v-model="user[0].userName" name="nameSurname" />
          <span class="text-danger text-sm" v-show="errors.has('nameSurname')">{{ errors.first("nameSurname") }}</span>

          <vs-input class="w-full mt-4" label="Telefon" v-model="user[0].phone" name="phone" />
          <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first("phone") }}</span>

          <vs-input class="w-full mt-4" label="Email" v-model="user[0].email" type="email" name="email" />
          <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>
          <div class="mt-4">
            <label class="vs-input--label">Yönetici</label>
            <v-select name="titleSelection" v-model="user[0].managerUserId" placeholder="Yönetici" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="mt-4">
            <label class="vs-input--label">Nakit Bölge</label>
            <v-select
              name="accountCompanyCashRegionName"
              v-model="user[0].accountCompanyCashRegionId"
              placeholder="Nakit Bölge"
              :options="accountCompanyCashRegionList"
              label="accountCompanyCashRegionName"
              class="w-full"
              :reduce="(row) => row.accountCompanyCashRegionId"
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="mt-4 w-full">
            <div class="vx-row w-full">
              <div class="vx-col md:w-1/4">
                <label class="vs-input--label">Şifre</label>
                <vs-input class="w-full " type="password" v-model="user[0].password" name="password" />
              </div>

              <div class="vx-col md:w-1/4">
                <label class="vs-input--label">Şifre Tekrar</label>
                <vs-input class="w-full" type="password" v-model="user[0].passwordVerify" name="passwordVerify" />
              </div>

              <div class="vx-col md:w-1/4" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '6') != null">
                <vs-button class="ml-auto mt-5" @click="savePassword" size="small" color="danger" v-if="user[0].userId != null && user[0].password != null && user[0].passwordVerify != null && user[0].password == user[0].passwordVerify"
                  >Password Güncelle</vs-button
                >
              </div>
            </div>
          </div>
          <div class="mt-4 w-full">
            <div class="vx-row">
              <div class="vx-col md:w-1/3">
                <label class="vs-input--label">Depo</label>
                <v-select name="label" v-model="user[0].warehouseId" placeholder="Depo" :options="warehouseList" label="warehouseName" :reduce="(row) => row.warehouseId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '6') != null" class="vx-col md:w-1/2 mt-5">
                <vs-button size="small" @click="saveWarehouse()" color="success">Depo Güncelle</vs-button>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-col md:w-1/2 w-full">
          <div class="mt-4">
            <label class="vs-input--label">Departman</label>
            <v-select name="departmentSelection" v-model="user[0].departmentId" placeholder="Departman" :options="departmentList" label="departmentName" class="w-full" :reduce="(row) => row.departmentId" @input="departmentSelected($event)">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('departmentSelection')">{{ errors.first("departmentSelection") }}</span>
          </div>

          <div class="mt-4">
            <label class="vs-input--label">Takım</label>
            <v-select name="teamSelection" v-model="user[0].teamId" placeholder="Takım" :options="teamList" label="teamName" class="w-full" :reduce="(row) => row.teamId" @input="teamSelected($event)">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('teamSelection')">{{ errors.first("teamSelection") }}</span>
          </div>

          <div class="mt-4">
            <label class="vs-input--label">Ünvan</label>
            <v-select name="titleSelection" v-model="user[0].titleId" placeholder="Ünvan" :options="titleList" label="titleName" class="w-full" :reduce="(row) => row.titleId">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('titleSelection')">{{ errors.first("titleSelection") }}</span>
          </div>

          <div class="mt-4">
            <label class="vs-input--label">İl</label>
            <v-select name="citySelection" v-model="user[0].cityId" placeholder="İl" :options="cityList" label="value" class="w-full" :reduce="(row) => row.id">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('citySelection')">{{ errors.first("citySelection") }}</span>
          </div>

          <div class="mt-4">
            <label class="vs-input--label">Bölge</label>
            <v-select name="regionSelection" v-model="user[0].regionId" placeholder="Bölge" :options="region" label="name" class="w-full" :reduce="(row) => row.id">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('regionSelection')">{{ errors.first("regionSelection") }}</span>
          </div>

          <div class="mt-4">
            <!-- <label class="vs-input--label">Kullanıcı Tipi</label>
            <v-select name="label" v-model="user[0].userType" placeholder="Kullanıcı Tipi" :options="userType" label="label" class="w-full" :reduce="(row) => row.id">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select> -->
               <label class="vs-input--label">Kullanıcı Tipi</label>
                <v-select name="label" v-model="user[0].userType" placeholder="Kullanıcı Tipi" :options="userTypeList" label="name" class="w-full" :reduce="(row) => row.name">
                  <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
          </div>

          <div class="mt-4 w-full">
            <div class="vx-row w-full">
              <div class="vx-col md:w-1/4">
                <label class="vs-input--label">Obd Device Serial Code</label>
                <vs-input class="w-full" v-model="user[0].obdDeviceSerialCode" name="obdDeviceSerialCode" />
              </div>

              <div class="vx-col md:w-1/4">
                <label class="vs-input--label">Verimor User Id</label>
                <vs-input class="w-full" v-model="user[0].verimorUserId" name="verimorUserId" type="number" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '6') != null">
        <div class="vx-col w-full">
          <div class="mt-8 flex justify-end">
            <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Kaydet</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Vazgeç</vs-button>
          </div>
        </div>
      </div>

      <!-- PERSONEL HESAP BİLGİLERİ BİLGİLERİ -->
      <template v-if="Object.keys(this.$route.params).length > 0">
        <div class="vx-row w-full" style="margin-bottom: 39px; justify-content: center; margin-top: 52px; font-size: xx-large;">
          <label>Personelin Hesap Hareketleri</label>
        </div>
        <div style="width: 100%;">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 w-full" style="display: flex; height: min-content;">
              <label class="vs-input--label">Hesap No</label>
            </div>
            <div class="vx-col md:w-1/5 w-full" style="display: flex; height: min-content;">
              <label class="vs-input--label">Hesap Adı ve Türü</label>
            </div>
            <div class="vx-col md:w-1/5 w-full" style="display: flex; height: min-content;">
              <label class="vs-input--label">Bakiye</label>
            </div>
            <div class="vx-col md:w-1/5 w-full" style="display: flex; height: min-content;">
              <label class="vs-input--label">Döviz Türü</label>
            </div>
          </div>
        </div>

        <div :key="i" v-for="(tr, i) in accountList" style="width: 100%;">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 w-full" style="display: flex; height: min-content;">
              <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.accountId" type="number" name="hesapno" />
            </div>
            <div class="vx-col md:w-1/5 w-full" style="display: flex; height: min-content;">
              <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.companyAccountName" type="text" placeholder="Hesap Adı ve Türü" name="companyAccountName" />
            </div>
            <div class="vx-col md:w-1/5 w-full" style="display: flex; height: min-content;">
              <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.balance" type="number" placeholder="Bakiye" name="Bakiye" />
            </div>
            <div class="vx-col md:w-1/5 w-full" style="display: flex; height: min-content;">
              <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.currencyName" type="text" placeholder="Para Tür" name="ParaTur" />
            </div>
            <div class="vx-col md:w-1/5 w-full mt-3" style="display: flex;">
              <vs-button class="mr-4 mb-4" @click="$router.push('../AccountCompanyMovementWatch/' + tr.accountId)">Hesap Hareketlerini İzle</vs-button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";
import vueAnkaCropper from "vue-anka-cropper";
import "vue-anka-cropper/dist/VueAnkaCropper.css";

export default {
  components: {
    vSelect,
    vueAnkaCropper,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cropData: null,
      showPopupPictureTool: false,
      departmentList: [],
      warehouseList: [],
      accountCompanyCashRegionList: [],
      accountList: [],
      userTypeList:[],
      userTypeSearch: { id: null, name: null },
      userList: [],
      teamList: [],
      titleList: [],
      cityList: [],
      region: [],
      picture: "",
      user: [
        {
          userId: null,
          status: 1,
          accountCompanyCashRegionId: null,
          phone: null,
          password: null,
          passwordVerify: null,
          roleList: [{ roleId: 0, roleName: null }],
          authorizationList: [{ authorizationId: 0, authorizationName: null }],
          departmentId: null,
          teamId: null,
          titleId: null,
          operation: null,
          managerUserId: null,
          createdDate: null,
          email: null,
          userName: null,
          cityId: null,
          regionId: null,
        },
      ],
      sampleData: [
        { name: "Teknik", val: ["ass", "1", "true", "000"] },
        {
          name: "Personel",
          val: ["false", "2", "1", "000"],
        },
        {
          name: "Stok",
          val: ["true", "false", "1", "000"],
        },
      ],
      status_local: "",
      role_local: "",
      data_local: {},
      statusOptions: [
        { label: "Çalışıyor", value: "true" },
        { label: "Ayrıldı", value: "false" },
      ],
      roleOptions: [
        { label: "Admin", value: "admin" },
        { label: "Kullanıcı", value: "user" },
      ],
      editUserDetails: {},
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },

  created: async function() {
    this.$vs.loading();

    //Güncelleme için URL den permissionId çekiliyor
    if (this.$route.params != null && this.$route.params.userId > 0) {
      this.user[0].userId = this.$route.params.userId;
      await this.getUser();
      this.user[0].operation = "UpdateUser";
    } else if (Object.keys(this.$route.params).length === 0 && this.$route.name == "UserAdd") {
      this.user[0].operation = "InsertUser";
    }

    Promise.all([this.getDepartment(), this.getTeam(), this.getTitle(), this.getUsers(), this.getCity(), this.getRegion(), this.GetAccountCompanyCashRegion(), this.GetWarehouse(), this.GetPersonnelImageStream(),this.getUserType()]);

    if (Object.keys(this.$route.params).length > 0) {
      Promise.all([this.getCompanyAccountList()]);
    }

    this.$vs.loading.close();
  },

  methods: {
     getUserType: async function () {
      this.$vs.loading();
      this.userTypeList = await repository.postEntity("ParametricScreens/getUserType", this.userTypeSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    save_changes: async function() {
      if (!this.validateForm) return;

      console.log(this.user[0]);
      if (this.user[0].operation == "InsertUser") {
        if (this.user[0].password != null && this.user[0].passwordVerify != null && this.user[0].password == this.user[0].passwordVerify) {
          null;
        } else {
          await this.$swal.fire({
            icon: "warning",
            title: "HATA",
            text: "Girdiğiniz şifre bilgileri aynı değildir. Lütfen kontrol ediniz.",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Tamam",
            cancelButtonText: "Hayır",
          });
          return;
        }
      }

      let resultConfirm = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        // text: "Devam etmek istediğinize emin misiniz?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm.isConfirmed) {
        this.$vs.loading();

        await repository.postEntity("HumanResource/saveUser", this.user[0]);

        this.$vs.loading.close();

        await this.$swal.fire({
          icon: "success",
          text: "Personel bilgileri başarılı bir şekilde kaydedildi.",
        });
      }
    },

    savePassword: async function() {
      let resultConfirm = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        // text: "Devam etmek istediğinize emin misiniz?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm.isConfirmed) {
        this.user[0].operation = "UpdateUserPassword";
        await repository.postEntity("HumanResource/saveUser", this.user[0]);

        await this.$swal.fire({
          icon: "success",
          text: "Personel Şifresi başarılı bir şekilde değiştirildi.",
        });
      }
    },

    saveWarehouse: async function() {
      let resultConfirm = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        // text: "Devam etmek istediğinize emin misiniz?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm.isConfirmed) {
        this.user[0].operation = "SaveWarehouse";
        await repository.postEntity("HumanResource/saveUser", this.user[0]);

        await this.$swal.fire({
          icon: "success",
          text: "Personel depo bilgisi başarılı bir şekilde değiştirildi.",
        });
      }
    },

    getCity: async function() {
      this.cityList = await repository.getAll("General/getCities").then((r) => r.list);
    },
    getRegion: async function() {
      this.region = await repository.getAll("General/getRegion").then((r) => r.list);
    },
    getCompanyAccountList: async function() {
      this.accountList = await repository.postEntity("Accounting/getCompanyAccount", { userId: this.user[0].userId, IsZeroBalanceIncluded: 0 }).then((r) => r.list);
    },
    GetWarehouse: async function() {
      this.warehouseList = await repository.postEntity("Purchase/getWarehouse", { getAllWarehouse: true }).then((r) => r.list);
    },

    GetAccountCompanyCashRegion: async function() {
      this.accountCompanyCashRegionList = await repository.postEntity("Accounting/GetAccountCompanyCashRegion", {}).then((r) => r.list);
    },

    getUsers: async function() {
      this.userList = await repository.postEntity("HumanResource/getUser", { status: 1 }).then((r) => r.list);
    },

    getDepartment: async function() {
      this.departmentList = await repository.getAll("HumanResource/getDepartment").then((r) => r.list);
    },

    departmentSelected: async function(e) {
      if (e != undefined && e != null) {
        this.getTeam();
        this.user[0].teamId = null;
      }
    },

    teamSelected: async function(e) {
      if (e != undefined && e != null) {
        null;
      }
    },

    getTeam: async function() {
      this.$vs.loading();
      this.teamList = await repository.postEntity("HumanResource/getTeam", { departmentId: this.user[0].departmentId }).then((r) => r.list);
      this.$vs.loading.close();
    },
    savePersonnelPicture: async function(e) {
      let resultConfirmForOverwrite = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: "Önceki resminiz kayıtlı ise üzerine yazılacaktır.",
        //input: "text",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (resultConfirmForOverwrite.isConfirmed) null;
      else return;

      this.$vs.loading();

      await repository.postBase64File("HumanResource/SavePersonnelPicture", this.user[0].userId, e.croppedImageURI);
      this.showPopupPictureTool = false;
      await this.GetPersonnelImageStream();
      this.$vs.loading.close();
    },

    GetPersonnelImageStream: async function() {
      let a;
      this.picture = null;
      this.picture = await repository
        .DownloadStream("HumanResource/DownloadPersonnelPicture" + "/" + this.user[0].userId)

        .then((response) => response.blob())
        .then(
          (blob) =>
            new Promise((callback) => {
              let reader = new FileReader();
              reader.onload = function() {
                callback(this.result);
              };
              reader.readAsDataURL(blob);
            })
        );

      return this.picture;
    },

    getTitle: async function() {
      this.$vs.loading();
      this.titleList = await repository.postEntity("HumanResource/getTitle", {}).then((r) => r.list);
      //this.user[0].titleId=null;
      this.$vs.loading.close();
    },

    getUser: async function() {
      this.$vs.loading();
      this.user = await repository.postEntity("HumanResource/getUser", { userId: this.user[0].userId }).then((r) => r.list);
      this.$vs.loading.close();
    },

    reset_data() {
      this.$router.push("/userView/" + this.$route.params.userId);
    },
  },
};
</script>

<style>
.vs-dialog {
}
.ankaCropper__saveButton {
  height: 33px;
}
.ankaCropper__navButton {
  padding: 0;
}
</style>
